import apiV2 from '../../api/v2';

export async function approveRetention(patientId: string, retainerOption: string): Promise<void> {
    await apiV2.post(`/patients/${encodeURIComponent(patientId)}/workflow/retention/approve`, {
        retainerOption
    });
}

export async function refuseRetentionContinue(patientId: string, reason: string): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/retention/refuse-continue`,
        { reason }
    );
}

export async function refuseRetentionEnd(patientId: string, reason: string): Promise<void> {
    await apiV2.post(`/patients/${encodeURIComponent(patientId)}/workflow/retention/refuse-end`, {
        reason
    });
}

export async function submitRetentionRecords(id: string): Promise<void> {
    await apiV2.post(`/patients/${encodeURIComponent(id)}/workflow/retention/submit-records`, {});
}

export async function deliverRetainers(id: string): Promise<void> {
    await apiV2.post(`/patients/${encodeURIComponent(id)}/workflow/retention/deliver`, {});
}
